<template>
    <div>
        <div class="text-right">
            <button class="btn btn-primary" @click="newWebChatGroup">
                <i class="fa fa-plus mr-1"></i> New Webchat Group
            </button>
        </div>
        <card-spinner style="height: 240px;" v-if="loadingGroups"></card-spinner>
        <div v-if="!loadingGroups">
            <div class="row">
                <div class="col-md-3">
                    <h5>Group Name</h5>
                </div>
                <div class="col-md-3">
                    <h5>Group Description</h5>
                </div>
                <div class="col-md-3">
                    <h5>Group Users</h5>
                </div>
                <div class="col-md-3">
                    &nbsp
                </div>
            </div>
            <hr>
            <webchat-group v-for="(group, index) of webChatGroups.data"
                                 :key="webChatGroups.id"
                                 :group="group"
                                 @openModal="openEditModal(group)"
                                 @deleteWebChatGroup="remove(group)"
                                 @replicatedWebChatGroup="fetchWebChatGroups"></webchat-group>
        </div>

        <pagination class="mt-3" :meta="webChatGroups" :links="webChatGroups" @page="gotoPage"></pagination>
        <modal  ref="modal" size="lg">
            <div class="d-block text-center" slot="title">
                <i v-if="edit"> Edit </i> <i v-else> Create </i> WebChat Group
            </div>
            <div class="p-2">
                <div class="row">
                    <div class="col">
                    <input-text label="Group Name" placeholder="Group Name" v-model="form.name" :form="form"
                                field="name" autofocus></input-text>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <input-text label="Group Description" placeholder="Group Description" v-model="form.description" :form="form"
                                    field="description"></input-text>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group" :class="{'is-invalid': form.errors.has('user_ids')}">
                            <label>Assign Users</label>
                            <multiselect :options="users"
                                         :multiple="true"
                                         track-by="id"
                                         label="name"
                                         :hide-selected="true"
                                         v-model="selectedUsers"
                                         :close-on-select="false"
                                         placeholder="Select one or more users">
                            </multiselect>
                            <p class="invalid-feedback" v-if="form && form.errors.has('user_ids')">
                                {{ form.errors.get('user_ids') }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" @click="save">Save</button>
            </span>
        </modal>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        data() {
            return {
                loadingGroups: true,
                webChatGroups        : {
                    data : [],
                    meta : null,
                    links: null,
                },
                sortBy: 'name|asc',
                selectedGroup: null,
                edit: false,
                form: new Form(),
                users: [],
                selectedUsers: [],
            }
        },

        created() {
            this.fetchTeamUsers();
            this.fetchWebChatGroups().then(() => this.loadingGroups = false);
            Bus.$on('LoadWebChatGroupList', () => this.fetchWebChatGroups());
        },

        computed: {
            ...mapState({
                filter: state => state.filter,
            }),
        },

        methods: {
            fetchWebChatGroups(page = 1) {
                this.loadingGroups = true;
                let params   = {
                    filter: {...this.filter},
                    page  : page,
                    sortBy: this.sortBy
                }
                return this.$http.get('/webchat-groups/',{params : params})
                    .then(({data}) => {
                        this.loadingGroups = false;
                        this.webChatGroups = data;
                        this.webChatGroups.prev = this.webChatGroups.prev_page_url;
                        this.webChatGroups.next = this.webChatGroups.next_page_url;
                    });
            },
            fetchTeamUsers() {
                return this.$http.get('/api/teams/current-team/users')
                    .then(({data}) => {
                        this.users = data.users;
                    });
            },

            gotoPage(page) {
                this.loadingGroups = true;
                this.fetchWebChatGroups(page).then(() => this.loadingGroups = false);
            },

            openEditModal(group) {
                this.edit = true;
                this.selectedGroup = group;
                this.form = new Form({
                    id: this.selectedGroup.id,
                    name: this.selectedGroup.name,
                    description: this.selectedGroup.description,
                    user_ids     : [],
                });
                this.selectedUsers = group.users;
                this.$refs.modal.open();
            },

            newWebChatGroup() {
                this.edit = false;
                this.selectedGroup = null;
                this.form = new Form({
                    name: null,
                    description: null,
                    user_ids     : [],
                });
                this.selectedUsers = [];
                this.$refs.modal.open();
            },

            save() {
                let uri    = this.$laroute.route('webchat-groups.store');
                let method = 'post';

                if (this.form.id) {
                    uri    = this.$laroute.route('webchat-groups.update', {webchat_group: this.form.id});
                    method = 'put';
                }

                this.form.user_ids = this.selectedUsers.map(user => user.id);

                return this.form[method](uri)
                    .then(() => {
                        this.fetchWebChatGroups();
                        swal.fire({
                            title: 'Saved',
                            text : 'WebChat Group Successfully saved',
                            type : 'success',
                        });
                        this.$refs.modal.close()
                    }).catch();
            },

            remove(group){
                this.$http.delete('/webchat-groups/' + group.id);
                const index = this.webChatGroups.data.findIndex(webChatGroup => webChatGroup.id === group.id);
                this.webChatGroups.data.splice(index, 1);
            }
        }

    }

</script>

<style lang="scss" scoped>
    .is-invalid {
        .invalid-feedback {
            display: block;
        }
    }
</style>
